

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var DECLINE_TYPE = {
    PRE_AUTH: 'PREAUTH'
};

/**
 * $SharedUtil is a resuable Angular factory service.
 * It intends to abstract away common functionalities that are
 * being used in multiple pages or components.
 */

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$SharedUtil', function () {

    /**
     *  checks if the current user is in CPA Treatment or Control.
     *  @returns {Promise} Represents current CPA treatment
     */
    var checkCpaElmoTreatment = function checkCpaElmoTreatment() {
        return (0, _squid.$elmo)('xo_hermesnodeweb_cpa', { 'ctx.country': _squid.$locale.country }, 'xo_hermesnodeweb_cpa_trmt').then(function (result) {
            return result && result.treatment_name;
        });
    };

    /**
     * Checks to see whether the current user is eligible for CPA elmo call.
     * return  the Treatment eligibility.
     *
     * @returns {Promise} Represents current CPA eligibility experience
     */
    var checkCpaEligibility = function checkCpaEligibility(checkoutSession) {
        var plans = checkoutSession.getPlanList();
        var declinedInstruments = checkoutSession.declinedInstruments || [];
        var cpaEligible = false;

        // Check if any existing plans has pre auth data.
        // if yes, then we make elmo call, otherwise not.
        if (plans && plans.length) {
            cpaEligible = plans.some(function (plan) {
                return plan.primaryFs && plan.primaryFs.pre_authorization_instruction;
            });
        }

        // if Plans does not have pre auth data then it might be possible that customer
        // has decline instuments which might be declined due to Pre Auth.
        if (!cpaEligible && declinedInstruments && declinedInstruments.length) {
            cpaEligible = declinedInstruments.some(function (instrument) {
                return instrument.decline_type === DECLINE_TYPE.PRE_AUTH;
            });
        }
        _logger.$logger.info('xo_hermes_cpa_eligibility', {
            cpaEligible: cpaEligible
        });

        // if still no Pre auth, user is not eligible for CPA. So no Elmo call.
        return cpaEligible ? checkCpaElmoTreatment() : _squid.$promise.resolve('');
    };

    var isBoolean = function isBoolean(value) {
        return Object.prototype.toString.call(value) === '[object Boolean]';
    };

    return {
        checkCpaEligibility: checkCpaEligibility,
        isBoolean: isBoolean
    };
});

_squid.$elmo;

_squid.$locale;

_squid.$promise;

_logger.$logger;


//////////////////
// WEBPACK FOOTER
// ./pages/services/shared-util/index.js
// module id = ./pages/services/shared-util/index.js
// module chunks = main-code-split